// @ts-nocheck
import { Navigate } from "react-router-dom"
import { CreatePostForm } from "@/components/post/CreatePostForm"
import { useAuth } from "@/components/layout/AuthProvider"

export default function CreatePostPage() {
  const { supabaseUser } = useAuth()
  if (!supabaseUser) return <Navigate to="/auth/login" replace />
  return (
    <div className="container-narrow py-4">
      <h1 className="font-bold text-xl mb-4">Create Post</h1>
      <CreatePostForm userId={supabaseUser.id} />
    </div>
  )
}